import { Type } from "@angular/core";

export class Field {
    constructor(
        public component: Type<any>,
        public options: any
    ) {}
}
